import axios from '../../axios';
import * as types from '../types';
import { setMsgInfo } from '..';
import filterError from '../common/filterError';
import API from '../api';

const baseUrl = API + '/admin/dashboard/';

export const fetchAdminDashboardData = () => {
  return async (dispatch) => {
    dispatch({ type: types.ADMIN_DASHBOARD_LOADING });
    try {
      const { data } = await axios.get(`${baseUrl}`);
      dispatch({
        type: types.FETCH_ADMIN_DASHBOARD_SUCCESS,
        payload: data,
      });
      return data;
    } catch (err) {
      const errors = filterError(err);
      dispatch({ type: types.ADMIN_DASHBOARD_FAILURE, payload: errors });
      dispatch(
        setMsgInfo({
          success: false,
          msg: errors,
        }),
      );
      throw err;
    }
  };
};
